import React from 'react'
import FileUploadWrapper from './components/FileUploadWrapper'

export default () => {
  return [
    {
      renderBlock(props, editor, next) {
        return <FileUploadWrapper {...props}>{next()}</FileUploadWrapper>
      },
    },
  ]
}
